import ApiCrud from "./api-crud";

class PagoSubcategoriaService extends ApiCrud {
  resource = "pago_subcategorias";
  primaryKey = "idpago_subcategoria";
}

export default new PagoSubcategoriaService();
